/* Fim de sessão.
 *
 * O `OnlyAuthenticated` só olhava se EXISTE token no localStorage, nunca se
 * ele ainda vale. Como o token JWT expira, o resultado era: a rota liberava,
 * toda chamada voltava 401, o componente tentava dar `.map` no corpo do erro e
 * a tela ficava BRANCA — sem mensagem, sem redirect, sem pista de que bastava
 * entrar de novo. Foi assim que a tela de médicos apareceu quebrada em
 * produção.
 *
 * Duas defesas, porque uma só não cobre:
 *
 * 1. `tokenValido()` — lê o `exp` do próprio JWT e trata token vencido como
 *    ausente. Pega o caso comum antes de qualquer requisição sair.
 * 2. `instalarInterceptador401()` — se o servidor recusar mesmo assim (token
 *    revogado, senha trocada, relógio fora de hora), encerra a sessão na hora.
 *
 * O login fica de fora do interceptador: lá o 401 significa "senha errada" e
 * quem trata é a própria tela.
 */
import AUTH_TOKEN from './constants/authToken'

const ROTAS_DE_LOGIN = ['/auth-user/', '/token-refresh/']

/** Payload do JWT, ou null se não der para ler. */
function payload(token) {
  try {
    const corpo = token.split('.')[1]
    if (!corpo) return null
    const json = atob(corpo.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export function tokenValido() {
  const token = localStorage.getItem(AUTH_TOKEN)
  if (!token) return false

  const dados = payload(token)
  // Sem `exp` legível, deixa passar: quem decide é o servidor, e o
  // interceptador abaixo cobre. Melhor do que deslogar quem está usando.
  if (!dados || !dados.exp) return true

  const agora = Math.floor(Date.now() / 1000)
  return dados.exp > agora
}

export function encerrarSessao() {
  localStorage.removeItem(AUTH_TOKEN)
  if (window.location.pathname !== '/login') {
    window.location.href = '/login?expirada=1'
  }
}

export function instalarInterceptador401() {
  const original = window.fetch

  window.fetch = async (...args) => {
    const resposta = await original(...args)

    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || ''
    const ehLogin = ROTAS_DE_LOGIN.some(rota => url.includes(rota))

    if (resposta.status === 401 && !ehLogin) encerrarSessao()

    return resposta
  }
}
